import { render, staticRenderFns } from "./TgAppBar.vue?vue&type=template&id=58785abc&"
import script from "./TgAppBar.vue?vue&type=script&lang=js&"
export * from "./TgAppBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports